import React, {useEffect, useState} from "react"
import {Outlet, useLocation, useNavigate, useOutletContext, useParams} from "react-router-dom"
import api, {requestFailed} from "../Scripts/api"
import Sidebar from "../Components/Sidebar";

function Account() {

    const navigate = useNavigate()
    const oc = useOutletContext().oc
    const locarr = useLocation().pathname.split('/').filter((char) => char !== '')
    const location = locarr[locarr.length - 1]
    const accountLocation = useParams().account
    const [viewingID, setViewingID] = useState()
    const [showSidebar, setShowSidebar] = useState(true)

    const getAccount = () => {
        api.get(`/api/getaccount`, {
            params: {account: accountLocation.split('').filter((char) => char !== '@').join('')}
        }).then((response) => {
            if (response.data.accountExists) setViewingID(response.data.accountID)
            else navigate("/404")
        }).catch(requestFailed)
    }

    useEffect(() => {
        getAccount()
        if (location.startsWith('@')) navigate('/' + accountLocation + "/profile")
        else if (!locarr[0].startsWith('@')) navigate("/404")
    }, [location])

    useEffect(() => {
        if (!oc.authChecked) return
        if ((location == "liked" || location == "settings") && oc.account != accountLocation.split('').filter((char) => char !== '@').join('')) navigate('/' + accountLocation + "/profile")
    }, [location, oc.authChecked, oc.account])

    useEffect(() => {
    	setShowSidebar(!oc.navOpen)
    }, [oc.navOpen])

    return (
        <div id="accountdiv">
            {accountLocation == '@' + oc.account && showSidebar && <Sidebar/>}
            <Outlet context={{oc: oc, viewingID: viewingID}}/>
        </div>
    )
}

export default Account;
